import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import Media from "react-media";

import "./sidenav.css";

// import SideNavLinkDiv
import SideNavLinkDiv from "./SideNavLinkDiv";
import { SubsectionLink } from "./SideNavLinks";

const SideNavComponent = ({
  isOpen,
  closeSideNav,
  activeUncheckedOrders,
  setSideNavOpen
}) => {
  // Original
  const [closeOnClick, setCloseOnClick] = useState(false);

  let location = useLocation();

  const voidFunction = () => {};

  const node = useRef();

  const handleOutsideClick = (event) => {
    if (node.current.contains(event.target)) {
      return;
    } else {
      setSideNavOpen(false);
    }
  };
  // Touch
  const [isDragging, setIsDragging] = useState(false);
  const [posLeft, setPosLeft] = useState(0);
  const [prevLeft, setPrevLeft] = useState(0);

  const divStyle = {
    left: closeOnClick ? (isOpen ? posLeft : "-80vw") : 0,
    overFlowX: "hidden"
  };

  const _onTouchStart = (event) => {
    setIsDragging(true);
    extractPositionDelta(event.nativeEvent.touches[0]);

    // these four lines added later
    const { left } = extractPositionDelta(event.nativeEvent.touches[0]);

    if (posLeft + left <= 0) {
      setPosLeft(posLeft + left);
    }
  };

  const _onTouchMove = (event) => {
    if (!isDragging) {
      return;
    }
    const { left } = extractPositionDelta(event.nativeEvent.touches[0]);

    if (posLeft + left <= 0) {
      setPosLeft(posLeft + left);
    }
  };

  const _onTouchEnd = (event) => {
    setIsDragging(false);

    let delta = Math.abs(prevLeft) - Math.abs(posLeft);

    if (delta < -30) {
      closeSideNav();
    }

    setPosLeft(0);
    setPrevLeft(0);
  };

  const extractPositionDelta = (event) => {
    const left = event.clientX;

    const delta = {
      left: left - prevLeft
    };

    setPrevLeft(left);

    return delta;
  };

  useEffect(() => {
    if (isOpen && closeOnClick) {
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.removeEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isOpen, closeOnClick]);

  return (
    <>
      <Media
        query="(min-width: 1000px)"
        onChange={(matches) => {
          if (matches) {
            setCloseOnClick(false);
            setSideNavOpen(true);
          } else {
            setCloseOnClick(true);
          }
        }}
      />
      <div
        className={`sidenav__containerDiv ${
          isOpen
            ? "sidenav__containerDiv--open"
            : "sidenav__containerDiv--closed"
        }`}
        ref={node}
        style={divStyle}
        onTouchStart={_onTouchStart}
        onTouchMove={_onTouchMove}
        onTouchEnd={_onTouchEnd}
        onTouchCancel={_onTouchEnd}
      >
        <hr />
        <div className="sidenav__linksContainerDiv">
          <SideNavLinkDiv
            to={"/orders"}
            linkName={`Orders ${
              activeUncheckedOrders.filter(
                (o) => o.orderType === "dailymenuOrder"
              ).length > 0
                ? ` (${
                    activeUncheckedOrders.filter(
                      (o) => o.orderType === "dailymenuOrder"
                    ).length
                  })`
                : ""
            }`}
            onClick={closeOnClick ? closeSideNav : voidFunction}
            currentLocation={location.pathname}
          ></SideNavLinkDiv>
          <SideNavLinkDiv
            to={"/menus"}
            linkName="Menus"
            onClick={closeOnClick ? closeSideNav : voidFunction}
            currentLocation={location.pathname}
          >
            <SubsectionLink
              to={"/menus/create_menu"}
              onClick={closeOnClick ? closeSideNav : voidFunction}
            >
              Create new menu
            </SubsectionLink>
          </SideNavLinkDiv>
          <SideNavLinkDiv
            to={"/items"}
            linkName="Items"
            onClick={closeOnClick ? closeSideNav : voidFunction}
            currentLocation={location.pathname}
          >
            <SubsectionLink
              to={"/items/create_item"}
              onClick={closeOnClick ? closeSideNav : voidFunction}
            >
              Create new item
            </SubsectionLink>
          </SideNavLinkDiv>
          <SideNavLinkDiv
            to={"/config"}
            linkName="Configurations"
            onClick={closeOnClick ? closeSideNav : voidFunction}
            currentLocation={location.pathname}
          ></SideNavLinkDiv>
          <SideNavLinkDiv
            to={"/orders_stats"}
            linkName="Orders stats"
            onClick={closeOnClick ? closeSideNav : voidFunction}
            currentLocation={location.pathname}
          ></SideNavLinkDiv>
          <SideNavLinkDiv
            to={"/posts"}
            linkName="Posts"
            onClick={closeOnClick ? closeSideNav : voidFunction}
            currentLocation={location.pathname}
          >
            <SubsectionLink
              to={"/posts/create_new"}
              onClick={closeOnClick ? closeSideNav : voidFunction}
            >
              Create new post
            </SubsectionLink>
          </SideNavLinkDiv>
        </div>
      </div>
    </>
  );
};

export default SideNavComponent;
